import { autoinject } from 'aurelia-framework';
import {DialogController} from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import { BusyService } from '../../services/busy-service';
import { CommentEntry } from '../../models/comment-entry';
import { SecurityService } from '../../services/security-service';

@autoinject
export class NewCommentDialog {
    insertedBy: string;
    canEdit: boolean = true;
    noteNotFound: boolean;
    constructor(
        private busyService: BusyService,
        protected controller: DialogController, private api: WebApiService) {
    }

    noteId: number;
    carrierId: number;
    carrierName: string;
    comment: string;
    visibilityRole: string = "View";    //default to view role
    allTags: string[] = ["Insurance", "Contract", "General", "Documents", "Special"];
    commentTags: string[] = [];

    async activate(params) {
        this.carrierId = params[0];
        this.carrierName = params[1];
        const noteId = params[2];
        if (noteId) {
            await this.loadComment(noteId);
        }
    }

    async loadComment(noteId: number) {
        this.busyService.on();
        this.api.get("Carriers", "GetCarrierComment", { noteId: noteId })
            .then((result) => {
                const commentEntry: CommentEntry = JSON.parse(result.response);
                if (commentEntry) {
                    this.noteId = commentEntry.id;
                    this.comment = commentEntry.comment;
                    if (commentEntry.tags) this.commentTags = commentEntry.tags.split(',');
                    this.insertedBy = commentEntry.insertedBy;
                    this.visibilityRole = commentEntry.visibilityRole;
                } else {
                    this.noteNotFound = true;
                    this.canEdit = false;
                }

            })
            .finally(() => this.busyService.off());
    }

    save() {
        //save comments immediately; low impact because they are append-only
        var params = {
            id: this.noteId,
            carrierId: this.carrierId,
            comment: this.comment,
            tags: this.commentTags,
            visibilityRole: this.visibilityRole
        };

        this.api.post("Carriers", "UpdateCarrierComment", params)
            .then(() => {
                $["notify"]("Comment saved", { className: "success", position: "top center" });
                this.controller.ok();
            }, (err) => {
                    let msg = "Error saving comment";
                    if (typeof err == "string") {
                        msg = err;
                    }
                $["notify"](msg, { className: "error", position: "top center" });
            });
    }


}